interface IInputUncontrolledProps {
  checked?: boolean;
  label: string;
  name: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value?: string | number;
  id?: string;
}

const InputUncontrolled: React.FC<IInputUncontrolledProps> = ({ checked, name, onChange, value, id }) => {
  return <input type="checkbox" id={id} name={name} onChange={onChange} value={value} defaultChecked={checked} />;
};

InputUncontrolled.displayName = 'InputUncontrolled';

export default InputUncontrolled;
